__turbopack_context__.v({
  "aside": "ProducerDetail-module-scss-module__rU_PkG__aside",
  "aside-wrapper": "ProducerDetail-module-scss-module__rU_PkG__aside-wrapper",
  "back": "ProducerDetail-module-scss-module__rU_PkG__back",
  "back-container": "ProducerDetail-module-scss-module__rU_PkG__back-container",
  "btn": "ProducerDetail-module-scss-module__rU_PkG__btn",
  "container": "ProducerDetail-module-scss-module__rU_PkG__container",
  "content": "ProducerDetail-module-scss-module__rU_PkG__content",
  "description": "ProducerDetail-module-scss-module__rU_PkG__description",
  "description-toggle": "ProducerDetail-module-scss-module__rU_PkG__description-toggle",
  "extra-img-overlay": "ProducerDetail-module-scss-module__rU_PkG__extra-img-overlay",
  "extra-info": "ProducerDetail-module-scss-module__rU_PkG__extra-info",
  "extra-push-down": "ProducerDetail-module-scss-module__rU_PkG__extra-push-down",
  "gallery": "ProducerDetail-module-scss-module__rU_PkG__gallery",
  "hidden": "ProducerDetail-module-scss-module__rU_PkG__hidden",
  "highlights": "ProducerDetail-module-scss-module__rU_PkG__highlights",
  "hr": "ProducerDetail-module-scss-module__rU_PkG__hr",
  "image": "ProducerDetail-module-scss-module__rU_PkG__image",
  "location": "ProducerDetail-module-scss-module__rU_PkG__location",
  "main": "ProducerDetail-module-scss-module__rU_PkG__main",
  "main-img-wrapper": "ProducerDetail-module-scss-module__rU_PkG__main-img-wrapper",
  "map": "ProducerDetail-module-scss-module__rU_PkG__map",
  "map-description": "ProducerDetail-module-scss-module__rU_PkG__map-description",
  "mobile-simulation-box": "ProducerDetail-module-scss-module__rU_PkG__mobile-simulation-box",
  "news": "ProducerDetail-module-scss-module__rU_PkG__news",
  "open": "ProducerDetail-module-scss-module__rU_PkG__open",
  "producer-info": "ProducerDetail-module-scss-module__rU_PkG__producer-info",
  "producer-location-wrapper": "ProducerDetail-module-scss-module__rU_PkG__producer-location-wrapper",
  "profile": "ProducerDetail-module-scss-module__rU_PkG__profile",
  "simulation-box": "ProducerDetail-module-scss-module__rU_PkG__simulation-box",
  "slide-down-out": "ProducerDetail-module-scss-module__rU_PkG__slide-down-out",
  "slide-in-up": "ProducerDetail-module-scss-module__rU_PkG__slide-in-up",
  "title-wrapper": "ProducerDetail-module-scss-module__rU_PkG__title-wrapper",
  "wrapper": "ProducerDetail-module-scss-module__rU_PkG__wrapper",
});
